import axios from "axios";
import { REACT_APP_API_KEY, REACT_APP_API_URL } from "./config";

const TOKEN_KEY = "officer_token";
const NAME_KEY = "officer_name";

export const getOfficerToken = () => localStorage.getItem(TOKEN_KEY);
export const getOfficerName = () => localStorage.getItem(NAME_KEY);

// Merge this into an axios `headers` object for any endpoint gated behind
// `auth:api` (e.g. boot-install).
export const officerAuthHeader = () => {
  const token = getOfficerToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const officerLogin = async (email, password) => {
  const response = await axios.post(
    `${REACT_APP_API_URL}auth/officer-login`,
    { email, password },
    { headers: { "api-key": REACT_APP_API_KEY } }
  );

  const data = response.data?.data;
  if (!data?.token) {
    throw new Error(response.data?.message || "Login failed");
  }

  const name = `${data.first_name || ""} ${data.last_name || ""}`.trim();
  localStorage.setItem(TOKEN_KEY, data.token);
  localStorage.setItem(NAME_KEY, name);
  return { token: data.token, name };
};

export const officerLogout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(NAME_KEY);
};
